import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-hub-600 hover:text-hub-700 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        
        <div className="bg-white rounded-xl shadow-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-hub-600" />
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          </div>
          
          <p className="text-sm text-gray-500 mb-8">Last Updated: January 6, 2026</p>
          
          <div className="prose prose-gray max-w-none">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using Hubtractor ("Platform"), you agree to be bound by these Terms of Service.
            </p>
            
            <h2>2. Description of Service</h2>
            <p>
              Hubtractor is a contractor management platform that enables entertainment contractors to 
              receive gig assignments, view schedules, track payments, and communicate with their booking agency.
            </p>
            
            <h2>3. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and 
              for all activities under your account. You agree to provide accurate and complete 
              information when creating your account.
            </p>
            
            <h2>4. SMS/Text Messaging Terms</h2>
            <p>
              By opting in to receive text messages, you consent to receive SMS notifications from 
              Hubtractor at the phone number provided. These messages may include:
            </p>
            <ul>
              <li>New gig assignments</li>
              <li>Schedule reminders and changes</li>
              <li>Payment confirmations</li>
              <li>Urgent operational updates</li>
            </ul>
            
            <p>
              <strong>Message Frequency:</strong> Varies based on your gig activity. Typically 2-10 
              messages per week for active contractors.
            </p>
            
            <p>
              <strong>Message and Data Rates:</strong> Standard message and data rates may apply 
              depending on your mobile carrier plan.
            </p>
            
            <p>
              <strong>Opt-Out:</strong> You may opt out at any time by replying STOP to any message 
              or by unchecking the SMS notification option in your profile settings.
            </p>
            
            <p>
              <strong>Help:</strong> Reply HELP to any message for assistance, or contact us at{' '}
              <a href="mailto:info@frequencyentertainment.net">info@frequencyentertainment.net</a>
            </p>
            
            <p>
              <strong>Carriers:</strong> SMS services are supported on all major U.S. carriers 
              including AT&T, Verizon, T-Mobile, and Sprint.
            </p>
            
            <h2>5. Contractor Relationship</h2>
            <p>
              Use of this Platform does not create an employer-employee relationship. All contractors 
              are independent contractors responsible for their own taxes and obligations.
            </p>
            
            <h2>6. Intellectual Property</h2>
            <p>
              The Platform and its content are owned by Hubtractor and protected by 
              applicable intellectual property laws.
            </p>
            
            <h2>7. Limitation of Liability</h2>
            <p>
              Hubtractor shall not be liable for any indirect, incidental, or 
              consequential damages arising from your use of the Platform.
            </p>
            
            <h2>8. Modifications</h2>
            <p>
              We reserve the right to modify these Terms at any time. Continued use of the Platform 
              constitutes acceptance of modified Terms.
            </p>
            
            <h2>9. Governing Law</h2>
            <p>
              These Terms are governed by the laws of the State of Nevada.
            </p>
            
            <h2>10. Contact</h2>
            <p>
              For questions about these Terms, contact:
            </p>
            <p>
              Hubtractor<br />
              Email: <a href="mailto:info@frequencyentertainment.net">info@frequencyentertainment.net</a><br />
              Phone: (702) 324-2583
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
